import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGetTableData } from '../../../../../hooks'
import { SmallDown } from '../../../../../components/Responsive/breakpoints'
import moment from 'moment'

const QAStatusScreen = ({ history }) => {
  const { token, bookingId } = useParams()

  const [modalImage, setModalImage] = useState(null)

  const {
    data: { list: booking },
  } = useGetTableData(`external/partnerBooking/${bookingId}/${token}`)

  return (
    <SmallDown>
      <div className='driver-booking-container-header-booking-support'>
        <img
          className='driver-back-icon mx-50%'
          src='/images/icon-back.png'
          alt=''
          onClick={() => {
            history.goBack()
          }}
        />
        <span style={{ paddingTop: '0.2em' }}>Quality check</span>
        <span style={{ paddingTop: '0.2em' }}></span>
      </div>
      {booking && booking.qaCheck && (
        <div className='driver-booking-container' style={{ margin: '5%' }}>
          <h5 className='mt-4 mb-4'>
            {' '}
            Quality check {booking.qaCheck.status}{' '}
          </h5>

          <div className='qa-block'>
            <div
              className='qa-content2'
              onClick={() => setModalImage(booking.qaCheck.chauffeurPhoto)}
              style={{ cursor: 'pointer' }}
            >
              <img
                className='qa-image2'
                src={booking.qaCheck.chauffeurPhoto}
                alt='Chauffeur'
              />
              <div className='qa-text-content2'>
                <div className='header'>
                  {booking.partnerOfBooking ? `Chauffeur's` : 'My'} photo
                </div>
                <div className='date'>
                  {moment(booking.qaCheck.createdAt).format(
                    'ddd, Do MMMM YYYY, HH:mm'
                  )}
                </div>
              </div>
            </div>

            {booking.qaCheck.status === 'failed' &&
              booking.qaCheck.reason &&
              booking.qaCheck.reason.chauffeur && (
                <div
                  className='partner-banner-thin mb-2'
                  style={{ justifyContent: 'flex-start' }}
                >
                  <div className='imageContainer'>
                    <img src='/images/icons/icon-warning.png' alt='' />
                  </div>
                  <div
                    className='partnerContainer'
                    style={{ fontSize: '14px' }}
                  >
                    <strong>Reason(s):</strong>&nbsp;
                    {booking.qaCheck.reason.chauffeurReason}
                  </div>
                </div>
              )}

            <div
              className='qa-content2'
              onClick={() => setModalImage(booking.qaCheck.vehiclePhoto)}
              style={{
                cursor: 'pointer',
                marginTop: '20px',
              }}
            >
              <img
                className='qa-image2'
                src={booking.qaCheck.vehiclePhoto}
                alt='Vehicle'
              />
              <div className='qa-text-content2'>
                <div className='header'>Vehicle's photo</div>
                <div className='date'>
                  {moment(booking.qaCheck.createdAt).format(
                    'ddd, Do MMMM YYYY, HH:mm'
                  )}
                </div>
              </div>
            </div>

            {booking.qaCheck.status === 'failed' &&
              booking.qaCheck.reason &&
              booking.qaCheck.reason.vehicle && (
                <div
                  className='partner-banner-thin mb-2'
                  style={{ justifyContent: 'flex-start' }}
                >
                  <div className='imageContainer'>
                    <img src='/images/icons/icon-warning.png' alt='' />
                  </div>
                  <div
                    className='partnerContainer'
                    style={{ fontSize: '14px' }}
                  >
                    <strong>Reason(s):</strong>&nbsp;
                    {booking.qaCheck.reason.vehicleReason}
                  </div>
                </div>
              )}
          </div>
        </div>
      )}
      {modalImage && (
        <div className='image-modal' onClick={() => setModalImage(null)}>
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
            onClick={e => e.stopPropagation()}
          >
            <img
              style={{
                cursor: 'pointer',
                marginBottom: '14px',
                width: '16px',
              }}
              onClick={() => setModalImage(null)}
              src='/images/icons/close-icon-black.png'
              alt=''
            />
            <img
              src={modalImage}
              alt='Preview'
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
              }}
            />
          </div>
        </div>
      )}
    </SmallDown>
  )
}

export default QAStatusScreen
